import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as AlertSVG } from "go-core/images/svg/alert.svg";
import FormatResourceStatus from "../../../../../../../../components/Common/Formatters/FormatResourceStatus/FormatResourceStatus";
import { SubscriptionApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import SubscriptionDate from "../Preview/SubscriptionDate";

interface Props {
	sub: SubscriptionApi;
}

const SubscriptionFormStatus = (props: Props) => {
	const { t } = useTranslation();
	const { sub } = props;
	// const isSubArchive = sub?.license_level === 'ARCHIVE';
	const isSubArchive = false;
	const status =
		sub.status === "CANCELLED" && sub.cancellation_reason === "WAITING_PAYMENT"
			? "EXPIRED"
			: isSubArchive
			? "PAUSED"
			: sub.status;

	return (
		<>
			<FormatResourceStatus status={status} />
			{sub.status === "CANCELLED" && (
				<OverlayTrigger
					placement="top"
					overlay={
						<Tooltip id={`tooltip-${sub.family_id}`}>
							{sub.cancellation_reason !== "OTHER" &&
								t(`constraints.SUBSCRIPTION_${sub.cancellation_reason}`)}
							{sub.cancellation_reason === "OTHER" &&
								t(`constraints.SUBSCRIPTION_${sub.cancellation_reason}`)}
							{sub.cancellation_reason === "OTHER" && sub.reason_details && <>: {sub.reason_details}</>}
						</Tooltip>
					}
				>
					{({ ref, ...triggerHandler }) => <AlertSVG className={"ms-1"} ref={ref} {...triggerHandler} />}
				</OverlayTrigger>
			)}
			{sub.status === "CANCELLED" && sub.cancellation_reason === "WAITING_PAYMENT" && (
				<SubscriptionDate subscription={sub} className="subscription-date" />
			)}
		</>
	);
};
export default SubscriptionFormStatus;
